import { Company } from "@/services/company-service";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { AlertTriangle } from "lucide-react";

interface DeleteCompanyDialogProps {
  company: Company | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: (id: string) => void;
}

export function DeleteCompanyDialog({ company, open, onOpenChange, onDelete }: DeleteCompanyDialogProps) {
  if (!company) return null;

  const handleDelete = () => { onDelete(company.id); onOpenChange(false); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader className="border-b pb-2">
          <DialogTitle className="text-sm font-semibold uppercase tracking-wide flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-4 w-4" />
            Deletar Empresa
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 py-2">
          <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-3">
            <p className="text-xs text-destructive font-medium">
              Atenção: Esta ação não pode ser desfeita. Todos os dados da empresa serão permanentemente removidos.
            </p>
          </div>

          <div className="space-y-1">
            <Label className="filter-label">Nome da Empresa</Label>
            <Input className="filter-input" value={company.name} disabled />
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-3 border-t">
          <Button variant="outline" size="sm" className="btn-header" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button variant="destructive" size="sm" className="btn-header" onClick={handleDelete}>Deletar Empresa</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
